import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { Link } from 'react-scroll';
import ServiceEventTracking from 'services/service.event-tracking';
import { getPublicPath } from 'utils/paths';
import {
  StyledHero,
  StyledHeroContainer,
  StyledHeroText,
  StyledHeroTitle,
  StyledImage
} from './Hero.styled';

const TEHero: React.FC = () => {
  const { t } = useI18n('talent-engine-landing-v3');

  return (
    <StyledHero>
      <StyledHeroContainer>
        <StyledHeroText>
          <StyledHeroTitle>
            {t('talent-engine-landing.hero.title')}
          </StyledHeroTitle>
          <HtmlTrans
            ns="talent-engine-landing-v3"
            i18nKey="talent-engine-landing.hero.desc"
          />
          <Link to="talentEngineForm" href="#talentEngineForm">
            <ButtonLink
              variant="primary"
              as="div"
              onClick={() =>
                ServiceEventTracking.trackLandingCtaClicked(
                  'talent-engine-quiero-hero'
                )
              }
            >
              <FontAwesomeIcon icon={faCheckCircle} />
              <span>{t('talent-engine-landing.hero.cta')}</span>
            </ButtonLink>
          </Link>
        </StyledHeroText>

        <StyledImage
          src={getPublicPath('/images/talentEngine/kanban-mock.png')}
        />
      </StyledHeroContainer>
    </StyledHero>
  );
};

export default TEHero;
